(function () {
    'use strict';

    angular
        .module('app.admin')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
            {
                state: 'admin',
                config: {
                    url: '/admin',
                    templateUrl: 'app/admin/admin.html?v=' + opsIncludeVersion,
                    controller: 'AdminController',
                    controllerAs: 'vm',
                    title: 'Admin',
                    settings: {
                        nav: 0,
                        content: '<i class="fa fa-cogs"></i> <span class="leftNavText">Admin</span>',
                        authMode: 1,
                        allowedUserTypes: [2, 1]
                    },
                    resolve: {
                        authenticationRequired: ['userService', function (userService) {
                            userService.isAuthenticatedThrowError();
                            if (userService.userType() == "0") {
                                throw { name: "NotAdmin" };
                            }
                        }]
                    }
                }
            }
        ];
    }
})();
